module.exports = (__webpack_require__(0))(323);


//////////////////
// WEBPACK FOOTER
// delegated ./src/templates/widgets/metadatumView.pug from dll-reference girder_lib
// module id = 166
// module chunks = 0